export default {
  title: 'Merken',
  form: {
    name: {
      placeholder: 'Merk zoeken...',
    },
  },
  fields: {
    id: '#',
    name: 'Naam',
    address: 'Adres',
    subdomain: 'Subdomein',
    shop_url: 'Shop-URL',
    companies: 'Bedrijven',
    slug: 'Slug',
    actions: '',
  },
  empty_list: 'Nog geen merken',
  modals: {
    delete_franchise: {
      title: 'Weet u zeker dat u het merk {{name}} wilt verwijderen?',
    },
  },
  buttons: {
    new_franchise: '+ Merk toevoegen',
    export_restaurants: 'Restaurants exporteren',
    edit: 'Bewerken',
    delete: 'Verwijderen',
    view_dashboard_as_owner: 'Dashboard bekijken als eigenaar',
    open_shop: 'Shop openen',
  },
  toasts: {
    failed_to_load_data: 'Gegevens laden mislukt',
    failed_to_delete_franchise: 'Verwijderen van merk mislukt',
    franchise_got_deleted: 'Merk is verwijderd',
    failed_to_create_magic_link: 'Magic link aanmaken mislukt',
    no_owner_to_log_in_as: 'Geen restauranteigenaar om als in te loggen',
  },
};
